var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLever(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8784 18.2657L16.243 15.6302C16.068 15.4553 15.7946 15.4553 15.6196 15.6302L12.9842 18.2657C12.8092 18.4297 12.8092 18.7031 12.9733 18.8672C13.0607 18.9546 13.181 19.0093 13.3013 18.9984H18.5722C18.8128 19.0093 19.0097 18.8125 19.0097 18.5828C19.0097 18.4625 18.9659 18.3423 18.8784 18.2657Z",
    fill: "#C3C6CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9647 8.7956L18.1336 6.34604C18.1008 6.23669 18.0352 6.13827 17.9586 6.05078L5.10938 18.9C5.18592 18.9656 5.28434 18.9984 5.38276 18.9984H9.03522C9.243 18.9984 9.43984 18.9219 9.582 18.7688L18.7897 9.57202C18.9975 9.36424 19.0631 9.06898 18.9647 8.7956Z",
    fill: "#E1E3E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6633 5.86506L15.2138 5.0449C14.9404 4.94648 14.6451 5.01209 14.4373 5.21987L5.22965 14.4166C5.08748 14.5588 5 14.7556 5 14.9634V18.6159C5 18.7143 5.03281 18.8127 5.09842 18.8893L17.9695 6.04003C17.882 5.96348 17.7727 5.9088 17.6633 5.86506Z",
    fill: "#C3C6CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLever);
export default __webpack_public_path__ + "static/media/lever.4dcd30e8914bbfa3d22a9f74fa038572.svg";
export { ForwardRef as ReactComponent };